<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
    <div class="jsgl-search">
      <el-input v-model="jsmc" clearable placeholder="请输入教师姓名" style="width: 180px;margin-right: 10px;margin-bottom: 10px;"></el-input>
      <el-button @click="searchJsgl" style="margin-right: 10px;margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
      <el-button type="primary" @click="addJsgl" style="margin: 0 10px 10px 0;" icon="el-icon-plus">新增</el-button>
    </div>
    <div class="jsgl-table">
      <el-table	:data="tableData" border :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column type="index" align="center" width="80" label="序号"></el-table-column>
        <el-table-column prop="jsbm" width="150" label="教师编号"></el-table-column>
        <el-table-column prop="jsmc" width="150" label="教师姓名"></el-table-column>
        <el-table-column prop="sjh" width="120" label="联系电话"></el-table-column>
        <el-table-column align="center" width="100" label="岗位状态">
          <template slot-scope="scope">
<!--            <span v-if="scope.row.zt == 0" style="color: #FF0000">离职</span>
            <span v-if="scope.row.zt == 1">在职</span>-->
            <el-tag size="mini" v-if="scope.row.zt==0" type="danger">离职</el-tag>
            <el-tag size="mini" v-if="scope.row.zt==1">在职</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="cjrmc" width="150" label="创建人">
        </el-table-column>
        <el-table-column align="center" width="160" label="创建时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.cjsj),'yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
<!--            <el-button type="text" @click="gwztEdit(scope.row.id, 1)" v-if="scope.row.zt == 0">重新入职</el-button>-->
            <el-button type="text" @click="gwztEdit(scope.row.id, 0)" v-if="scope.row.zt == 1">离职</el-button>
            <el-button type="text" @click="xgmmClk(scope.row.id)" v-if="scope.row.zt == 1">重置密码</el-button>
            <el-button type="text" @click="jsglShow(scope.row.id)" v-if="scope.row.zt == 1">编辑</el-button>
            <el-button type="text" @click="jsglDel(scope.row.id)" v-if="scope.row.zt == 0">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="page-zj"
          v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
      </el-pagination>

      <el-dialog
          :title="dialogTitle?'编辑':'新增'"
          :visible.sync="dialogVisible"
          width="30%"
          @close="handleClose"
          :close-on-click-modal="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
<!--          <el-form-item label="教师编号" prop="jsbm">
            <el-input v-model="ruleForm.jsbm" show-word-limit maxlength="20" clearable placeholder="请输入教师编号"></el-input>
          </el-form-item>-->
          <el-form-item label="教师名称" prop="jsmc">
            <el-input v-model="ruleForm.jsmc" show-word-limit maxlength="30" clearable placeholder="请输入教师名称"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="sjh">
            <el-input v-model="ruleForm.sjh" show-word-limit maxlength="11" clearable placeholder="请输入联系电话"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="jsglSave('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 修改密码 -->
      <el-dialog title="设置密码" :close-on-click-modal="false" :visible.sync="dialogEditPwdForm" width="600px">
        <div class="newpassword" style="margin-bottom: 10px">
          <label style="margin-left: 28px">新密码: &nbsp;&nbsp;</label>
          <el-input style="display: inline-block;width: 80%" v-model="newpassword" type="password" show-password :placeholder="pwdTipe"></el-input>
        </div>
        <div class="repassword">
          <label>新密码确认: &nbsp;&nbsp;</label>
          <el-input style="display: inline-block;width: 80%" v-model="repassword" type="password" show-password :placeholder="'新'+pwdTipe"></el-input>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogEditPwdForm = false">取 消</el-button>
          <el-button type="primary" @click="eidtPassword()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
	</div>
</template>

<script>
	export default{
		name: "jsglList",
		data() {
		  return {
        jgglId: sessionStorage.getItem("jgglId"),
        loading: false,
        tableData: [],
        page: { page: 1, size: 10, total: 0 },
        jsmc: '',//教师名称
        dialogVisible: false,
        dialogTitle: false,
        ruleForm: {
          id: '',
          jgglId: '',
          //jsbm: '',
          jsmc: '',
          sjh: '',
        },
        rules: {
          /*jsbm: [
            { required: true, message: '请输入教师编号', trigger: 'blur' },
          ],*/
          jsmc: [
            { required: true, message: '请输入教师名称', trigger: 'blur' },
          ],
          sjh: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
          ]
        },
        jsglId: '',
        dialogEditPwdForm: false,
        newpassword: '',//新密码
        repassword: '',//确认密码
        passwordRule: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>|\[\]\\\/?])[\S\s]{8,16}$',
        pwdTipe: '密码应由8到16位且包含大小写字母、特殊符号和数字组成',
		  }
		},
		mounted() {
      this.getConfigInfo();
			this.findJiaoshiPage();
		},
		methods: {
      //获取系统配置信息
      getConfigInfo(){
        this.$post('sys/findSysConfigByConfigKey',{configKey: "password_rule"}).then((rep) => {
          this.passwordRule = rep.result.sysConfig.configValue;
          this.pwdTipe = rep.result.sysConfig.configDes;
        })
      },
      // 修改密码
      xgmmClk(id) {
        var _this = this;
        _this.$post('user/yonghuList',{jiaoshiId: id}).then((rep) => {
          if(rep.code == 1){
            var user =rep.result.yonghuList;
            if(user.length>0){
              _this.yhId = rep.result.yonghuList[0].id;
              _this.newpassword = '';
              _this.repassword = '';
              _this.dialogEditPwdForm = true;
            }else{
              _this.$message({
                type: "error",
                message: "无该教师用户信息"
              });
            }
          }else{
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
      //修改密码
      eidtPassword(){
        if(this.newpassword==""){
          this.$message({
            type: "error",
            message: "请输入新密码"
          });
          return;
        }else{
          var checkPwd = this.checkPwd(this.newpassword,this.passwordRule);
          if(!checkPwd){
            this.$message({
              type: "error",
              message: "新"+this.pwdTipe
            });
            return;
          }
        }
        if(this.repassword==""){
          this.$message({
            type: "error",
            message: "请输入确认密码"
          });
          return;
        }else{
          var checkPwd = this.checkPwd(this.repassword,this.passwordRule);
          if(!checkPwd){
            this.$message({
              type: "error",
              message: "确认"+this.pwdTipe
            });
            return;
          }else{
            if(this.newpassword!=this.repassword){
              this.$message({
                type: "error",
                message: "两次密码不一致"
              });
              return;
            }
          }
        }
        var _this = this;
        var params = {
          "userId":this.yhId,
          "newPassword":this.newpassword
        };
        _this.$post("user/eidtPassword",params).then(function(response) {
          if (response.result == "1") {
            _this.$message({
              type: "success",
              message: response.message
            });
            _this.dialogEditPwdForm = false;
            _this.findJiaoshiPage();
          } else {
            _this.$message({
              type: "error",
              message: response.message
            });
          }
        }).catch(function(error) {
          // console.error(err);
        });
      },
      gwztEdit(id, zt){
        var _this = this;
        _this.$confirm('是否确认'+ (zt == 1 ? '重新入职' : '离职'), '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.loading = true;
          _this.$post('jiaoshi/JiaoshiController/jiaoshiZtEdit',{id: id, zt: zt}).then(rep => {
            _this.loading = false;
            if (rep.code == 1) {
              _this.$message({
                type: "success",
                message: '操作成功'
              });
              _this.findJiaoshiPage();
            } else {
              _this.$message({
                type: "error",
                message: rep.msg
              });
            }
          })
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消'
          });
        })
      },
      jsglSave(formName){
        var _this = this;
        _this.$refs[formName].validate((valid) => {
          if(valid){
            _this.loading = true;
            _this.$post('jiaoshi/JiaoshiController/jiaoshiSave',this.ruleForm, 'json').then((rep) => {
              _this.loading = false;
              if (rep.code == 1) {
                _this.$message({
                  type: "success",
                  message: this.dialogTitle ? '编辑成功' : '添加成功'
                });
                _this.dialogVisible = false;
                _this.findJiaoshiPage();
              } else {
                _this.$message({
                  type: "error",
                  message: rep.msg
                });
              }
            });
          }else {
            return false;
          }
        });
      },
      jsglShow(id){
        var _this = this;
        _this.loading = true;
        _this.$post('jiaoshi/JiaoshiController/jiaoshiView',{id: id}).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            var jiaoshi = rep.result.jiaoshi;
            _this.ruleForm.id = jiaoshi.id;
            _this.ruleForm.jgglId = jiaoshi.jgglId;
            //_this.ruleForm.jsbm = jiaoshi.jsbm;
            _this.ruleForm.jsmc = jiaoshi.jsmc;
            _this.ruleForm.sjh = jiaoshi.sjh;

            _this.dialogVisible = true;
            _this.dialogTitle = true;
          }else{
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        });
      },
      addJsgl(){
        var _this = this;
        _this.ruleForm.jgglId = _this.jgglId;
        _this.dialogVisible = true;
        _this.dialogTitle = false;
      },
      // 弹窗关闭时
      handleClose() {
        var _this = this;
        _this.$refs['ruleForm'].resetFields();
        _this.ruleForm = {
          id: '',
          jgglId: '',
          //jsbm: '',
          jsmc: '',
          sjh: ''
        };
        _this.dialogVisible = false;
      },
      jsglDel(id){
        var _this = this;
        _this.$post("jiaoshi/JiaoshiController/jiaoshiBjList", { id: id }).then(rep => {
          if (rep.code == 1) {
            _this.$confirm(rep.result.jiaoshiList.length > 0 ? '该教师已在班级存在，是否确认删除':'是否确认删除', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              _this.$post("jiaoshi/JiaoshiController/jiaoshiDel", { id: id }).then(rep => {
                if (rep.code == '1') {
                  _this.$message({
                    type: "success",
                    message: '删除成功'
                  });
                  _this.findJiaoshiPage();
                } else {
                  _this.$message({
                    type: "error",
                    message: rep.msg
                  });
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            })
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
            return;
          }
        })
      },
      searchJsgl(){
        var _this = this;
        _this.page.page = 1;
        _this.findJiaoshiPage();
      },
      findJiaoshiPage(){
        var _this = this;
        var params = {
          jgglId: _this.jgglId,
          jsmc: _this.jsmc,
          page: _this.page.page - 1,
          size: _this.page.size
        }
        _this.loading = true;
        _this.$post('jiaoshi/JiaoshiController/jiaoshiPage',params).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            _this.tableData = rep.result.page.content;
            _this.page.total = rep.result.page.totalElements;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
				})
			},
      // 每页条数
      handleSizeChange(val) {
        this.page.size = val;
        this.findJiaoshiPage();
      },
      // 当前页
      handleCurrentChange(val) {
        this.page.page = val;
        this.findJiaoshiPage();
      },
		}
	}
</script>

<style lang="less" scoped>
  .jsgl-search{
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
  }
	.jsgl-table{
		.el-table{
		}
		.page-zj{
			width: 90%;
			text-align: right;
			margin: 0 auto;
			margin-top: 20px;
		}
	}
  .el-dialog{
    .el-form{
      padding-right: 25px;
      .el-select{
        width: 100%;
      }
      .el-date-editor{
        width: 100%;
      }
    }
  }
</style>